import { Text } from '../../Atoms/Text';
import { usaCurrency, formatInfo, formatDate } from '../../../utils/helpers';

export interface DetailRowProps {
  title: string;
  value: string;
  colId: string;
  gutterBottom?: boolean;
  contentHighlightColor?: string;
  testId?: string;
  labelWidth?: string;
}

const currencyRows: string[] = ['mRC', 'nRC'];
const dateRows: string[] = [
  'completionDate',
  'contractEndDate',
  'firstInvoiceReviewedByDate',
  'disconnectedDate',
  'serviceActivationDate',
  'billingCommencementDate',
  'startDate',
  'focDate',
  'estimatedDeliveryDate',
  'customerRequestedDate'
];
const infoRows: string[] = [
  'iPDetails',
  'lecDemarc',
  'locationAText',
  'locationZLecCircuitId',
  'locationZLecDemarc',
  'locationZLocalLec',
  'locationALecDemarc',
  'locationALocalLec',
  'locationALecCircuitId',
  'phoneNumbers',
  'circuitIDs',
  'lecCircuitID'
];
const multilineRows: string[] = ['nextSteps'];

const formatValue = (value: string, colId: string) => {
  if (currencyRows.includes(colId)) return `${usaCurrency.format(Number(value))}`;
  if (dateRows.includes(colId)) {
    if (!value) {
      return '';
    }
    // formatDate rearranges the string without parsing, so ISO dates and datetimes
    // render as the stored calendar day in every timezone; non-ISO values pass through.
    return formatDate(value);
  }
  if (infoRows.includes(colId)) return formatInfo(value);

  return value;
};

export function DetailRow({
  title,
  value,
  colId,
  gutterBottom = true,
  contentHighlightColor = '',
  testId = `detail-row-${title}`,
  labelWidth = 'w-full'
}: DetailRowProps) {
  return (
    <div
      className={`flex${gutterBottom ? ' mb-8' : ''}`}
      data-testid={testId}>
      <Text
        className={`font-sans text-grey-4 ${contentHighlightColor ? 'w-1/2 ' : labelWidth}`}
        size="sm14">
        {title}
      </Text>
      <Text
        className={`font-sans font-normal ${contentHighlightColor ? `${contentHighlightColor} text-white w-fit whitespace-nowrap px-[9px] py-[2px] rounded-full` : `w-full${multilineRows.includes(colId) ? ' whitespace-pre-wrap' : ''}`}`}
        size="sm">
        {formatValue(value, colId)}
      </Text>
    </div>
  );
}
